import React from 'react';
import { Check } from 'lucide-react';
import { WHY_POINTS, STATS } from '../mock';
import logo from '../assets/collins_logo.png';

const WhyUs = () => (
  <section id="why-us" className="bg-app py-24 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
      <div>
        <span className="text-xs tracking-[0.3em] text-sky-400 uppercase font-semibold">Why Collins Tech</span>
        <h2 className="mt-3 font-cond font-700 text-4xl md:text-5xl text-white">Precision repair. Honest service.</h2>
        <p className="mt-5 text-gray-400 leading-relaxed max-w-xl">
          Collins Technologiez LLC is built on a simple promise: diagnose the real problem,
          fix it right the first time, and stand behind the work. No upselling. No guesswork.
        </p>
        <ul className="mt-8 space-y-3.5">
          {WHY_POINTS.map((pt) => (
            <li key={pt} className="flex items-start gap-3">
              <span className="mt-0.5 w-5 h-5 rounded-full bg-sky-500/15 flex items-center justify-center shrink-0">
                <Check className="w-3.5 h-3.5 text-sky-400" />
              </span>
              <span className="text-gray-300 text-[15px]">{pt}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="relative">
        <div className="card-dark rounded-2xl p-10 flex flex-col items-center text-center">
          <img src={logo} alt="Collins Technologiez LLC" className="w-full max-w-[280px] h-auto object-contain drop-shadow-[0_10px_30px_rgba(0,0,0,0.5)]" />

          <div className="mt-8 grid grid-cols-3 gap-4 w-full">
            {STATS.map((s) => (
              <div key={s.label} className="rounded-xl bg-white/5 border border-white/10 py-5">
                <div className="font-cond font-700 text-2xl text-sky-400">{s.value}</div>
                <div className="text-xs text-gray-400 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default WhyUs;
